<template>
  <div>
<!--  <h3 class="text-3xl text-left text-semibold">General</h3>-->
        <p class="text-left text-sm leading-relaxed mt-4">
          The platform is open-sourced and aims to work as a higher-level development framework to support the easier
          development of interactive tools for 3D model visualization on the web.
          The IH-AT platform handles all the required processes for authorization and initialization purposes, isolating
          the steps needed to develop every single interactive tool.
          Docker.
        </p>
        <p class="text-left text-sm leading-relaxed mt-4">
          This approach facilitates non-expert JavaScript
          users, without a-priori knowledge of the Back-end technologies, to customize the existing platform
          capabilities and add new interactive WebGL features.
          The IH-AT platform is currently pre-configured to be easily deployable in containerized environments using
          Docker.
        </p>
        <p class="text-left mt-8">
          <ul class="list-inside list-disc">
          <li><small><a href="https://github.com/APAC-StarC/modelier" target="_blank" class="text-blue-500 hover:underline">Github Repository</a></small></li>
          <li><small><a href="https://modelier.us.aldryn.io/models/13e7c708-4b03-40d0-93b5-d94f45629046/v2/embed/" target="_blank" class="text-blue-500 hover:underline">Check the full model</a></small></li>
          </ul>
        </p>

    </div>
</template>

<script>
export default {
  name: 'TabDevelopmentFramework',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
